export default {
    root: '/api',
    reporting: '/reporting/api/report'
};

